import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dccd1f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "login-main" }
const _hoisted_3 = { class: "login-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "央邦车辆管理系统")
], -1))
const _hoisted_5 = { class: "login-form" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_button = _resolveComponent("i-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.no) = $event)),
            placeholder: "请输入工号"
          }, null, 512), [
            [_vModelText, _ctx.params.no]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.pwd) = $event)),
            placeholder: "请输入密码"
          }, null, 512), [
            [_vModelText, _ctx.params.pwd]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "code-left",
            onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.code) = $event)),
            placeholder: "请输入验证码"
          }, null, 544), [
            [_vModelText, _ctx.params.code]
          ]),
          _createElementVNode("img", {
            src: _ctx.imgUrl,
            alt: "验证码",
            class: "login-code",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.imageClick && _ctx.imageClick(...args)))
          }, null, 8, _hoisted_6),
          _createVNode(_component_i_button, {
            type: "primary",
            class: "login-submit",
            onClick: _ctx.goHome
          }, {
            default: _withCtx(() => [
              _createTextVNode("登录")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}